import ShoppingCart from "@/models/ShoppingCart.js";

export default {
  namespaced: true,
  state: {
    shoppingCart: {},
    discountId: null,
  },
  mutations: {
    setShoppingCart(state, shoppingCart) {
      state.shoppingCart = shoppingCart;
    },
    setDiscountId(state, discountId) {
      state.discountId = discountId;
    },
  },
  actions: {
    async fetchShoppingCart({ commit, getters }) {
      const shoppingCart = new ShoppingCart();
      const discountId = getters.getDiscountId;
      const record = await shoppingCart.fetch(discountId);

      commit("setShoppingCart", record);
      return record;
    },
    async removeShoppingCartItem({ dispatch, getters }, itemId) {
      const shoppingCart = getters.getShoppingCart;

      await shoppingCart.removeItem(itemId);
      await dispatch("fetchShoppingCart");
    },
    async addShoppingCartItem({ dispatch, getters }, params) {
      const shoppingCart = getters.getShoppingCart;

      await shoppingCart.addItem(params);
      await dispatch("fetchShoppingCart");
    },
    async applyDiscount({ commit }, discountId) {
      commit("setDiscountId", discountId);
    },
  },
  getters: {
    getShoppingCart(state) {
      return new ShoppingCart(state.shoppingCart);
    },
    getDiscountId(state) {
      return state.discountId;
    },
  },
};
